import { createFileRoute } from "@tanstack/react-router";
import { SuppliersWorkspace } from "@/components/AdditionalWorkspaces";

export const Route = createFileRoute("/suppliers")({ component: SuppliersWorkspace });
